import template from './suburban-total-area.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.suburbanTotalArea', [])
    .directive('cianAfAboutObjectSuburbanTotalArea', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.areaMin = 0;
            this.areaMax = 10000000;

            this.validation = validation(this.form, 'suburbanTotalArea', {
                required: 'Укажите площадь дома',
                parse: 'Введите число',
                min: 'Площадь должна быть больше 0',
                max: 'Допустимо не более 7 символов',
            });
        }],
        controllerAs: 'suburbanTotalArea',
        template,
    }))
    .name;
